module.exports = __webpack_public_path__ + "img/eye_green.196ade43.svg";